import React, { Component } from 'react'
import { GenerateLink } from 'scripts/helpers/AppHelper'
import locale, {getLang} from 'shared/i18n/react'
import { actions } from 'scripts/store'

const customOnClick = () => {
  actions.setSection('footer')
}

function mapLinks(item, index) {
  let link = null
  if (item.type) {
    link = <GenerateLink {...item} customOnClick={customOnClick} />
  } else {
    link = <a {...item}>{item.title}</a>
  }

  return (
    <li className="footer-list-item" key={index}>{link}</li>
  )
}

class Footer extends Component {
  constructor(props) {
    super(props)
    this.lang = getLang()
    const {footer} = locale
    this.links = [
      { type: 'page', slug: 'about', title: footer.links.about, element: footer.links.about },
      { type: 'page', slug: 'terms', title: footer.links.terms, element: footer.links.terms },
      { type: 'page', slug: 'privacy', title: footer.links.privacy, element: footer.links.privacy },
      { type: 'page', slug: 'cookies', title: footer.links.cookie, element: footer.links.cookie },
      { type: 'page', slug: 'copyright', title: footer.links.copyright, element: footer.links.copyright },
      { href: 'mailto:viki-sales@mail.rakuten.com', title: footer.links.adInfo },
      { type: 'page', slug: 'soompi-community-guidelines', title: footer.links.guide, element: footer.links.guide },
      { href: 'https://support.soompi.com/', title: footer.links.help, target: '_blank' },
      { type: 'page', slug: 'jobs', title: footer.links.jobs, element: footer.links.jobs },
      { type: 'page', slug: 'apps', title: footer.links.apps, element: footer.links.apps }
    ]

    this.follow = {
      en: [
        { href: 'https://www.facebook.com/soompi', title: 'Facebook', target: '_blank' },
        { href: 'https://twitter.com/soompi', title: 'Twitter', target: '_blank' },
        { href: 'https://www.youtube.com/user/soompi', title: 'YouTube', target: '_blank' },
        { href: 'https://www.instagram.com/soompi', title: 'Instagram', target: '_blank' },
        { href: 'https://soompi.tumblr.com', title: 'Tumblr', target: '_blank' },
        { href: 'https://plus.google.com/+SoompiKpop', title: 'Google+', target: '_blank' }
      ],
      es: [
        { href: 'https://www.facebook.com/soompispanish', title: 'Facebook', target: '_blank' },
        { href: 'https://twitter.com/soompispanish', title: 'Twitter', target: '_blank' },
        { href: 'https://www.youtube.com/user/soompi', title: 'YouTube', target: '_blank' },
        { href: 'https://www.instagram.com/soompispanish', title: 'Instagram', target: '_blank' },
        { href: 'https://soompi.tumblr.com', title: 'Tumblr', target: '_blank' },
        { href: 'https://plus.google.com/+SoompiKpop', title: 'Google+', target: '_blank' }
      ]
    }
    this.date = new Date()
  }

  render() {
    return (
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col small-12 med-4">
              <div className="columnize-links columnize-links-wrapper-small">
                <h3 className="header muted-light uppercase">{locale.footer.follow}</h3>
                <ul>{this.follow[this.lang].map(mapLinks)}</ul>
              </div>
            </div>
            <div className="col small-12 med-4">
              <div className="columnize-links columnize-links-wrapper-med">
                <h3 className="header muted-light uppercase">{locale.footer.sitemap}</h3>
                <ul>{this.links.map(mapLinks)}</ul>
              </div>
            </div>
            <div className="col small-12 med-4 footer-language">
              <div className="columnize-links columnize-links-wrapper-med">
                <h3 className="header muted-light uppercase">{locale.footer.language}</h3>
                <div className="contrast strong footer-language">
                  <a href="/" className={`${this.lang === 'en' ? 'active' : ''}`}>{locale.footer.english}</a>
                  <span className="vertical-separator"/>
                  <a href="/es" className={`${this.lang === 'es' ? 'active' : ''}`}>{locale.footer.spanish}</a>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright">
            <div>&copy; 1998 &ndash; {this.date.getFullYear()} Viki Inc.</div>
            <div>{locale.formatString(locale.footer.family, <a href="https://www.viki.com" target="_blank">Rakuten Viki</a>)}</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./assets/js/components/static/footer.jsx